import { Iso8601DateTimeString } from '../../../../../../types/Iso8601DateTimeString';
import { Text } from '../../../../../cdl/Text/Text';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { isNoticeDaysExceeded } from '../../../../../common/helpers/isNoticeDaysExceeded.helper';
import { translate } from '../../../../../common/helpers/translate.helper';
import { OfferState } from '../../../../../offer/model/OfferState';

interface RfqOfferNoticeDaysDisplayProps {
    noticeDays?: number;
    dateDelivery: Iso8601DateTimeString;
    offerState: OfferState;
}

export const RfqOfferNoticeDaysDisplay = ({ noticeDays, dateDelivery, offerState }: RfqOfferNoticeDaysDisplayProps) => {
    if (!noticeDays) {
        return null;
    }

    const noticeDaysString = translate('order.detail.daysNotice', { days: noticeDays.toString() });

    const isRelevantState = offerState === OfferState.ENQUIRY || offerState === OfferState.QUOTED;

    if (isRelevantState && isNoticeDaysExceeded(dateDelivery, noticeDays)) {
        return (
            <Tooltip label={translate('order.detail.etdIsBelowNoticeDays')} showArrow side="right">
                <Text variant="extraSmall" color="attention.foreground" fontWeight={600}>
                    {noticeDaysString}
                </Text>
            </Tooltip>
        );
    }

    return <Text variant="extraSmall">{noticeDaysString}</Text>;
};
